<body>
    <div class="grid-overlay">
        <app-page-header>
            <button class="header-action-btn"> <a routerLink="/my-portals">{{ 'congratulation.viewPortals' | translate }}</a></button>
        </app-page-header>
        <div class="setting-data">
            <div class="content-thanks">
                
            <div class="second-headboard">
                <h1>{{ 'congratulation.title' | translate }}</h1>
                <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->
              
            </div>
            <img style="width: 350px;height: 260px;object-fit: cover;" src="../../assets/images/process.gif" alt="">
            <p>{{ 'congratulation.redirecting' | translate: {seconds: countdown} }}</p>
            <div class="gracias_text">
            <p>{{ 'congratulation.message1' | translate }}</p>
            <p>{{ 'congratulation.message2' | translate }}</p>
            <p>{{ 'congratulation.message3' | translate }}</p>
           </div>
           
        </div>
           </div>
            </div>
        
</body>
